var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
/*
SPDX-FileCopyrightText: 2023 Genome Research Ltd.

SPDX-License-Identifier: MIT
*/
import { Checkbox, CheckPicker as RSCheckPicker } from 'rsuite';
import { isPropDefined } from '../general/Utils';
function MultipleSelect(props) {
    var data = props.data, value = props.value, setValue = props.setValue, placeholder = props.placeholder, disabled = props.disabled, loading = props.loading, open = props.open, onOpen = props.onOpen, onEntering = props.onEntering, onClose = props.onClose, onClick = props.onClick, renderMenuItem = props.renderMenuItem, renderValue = props.renderValue, noSearch = props.noSearch;
    var block = isPropDefined(props.block);
    var formattedData = data.map(function (item) {
        return ({ label: item, value: item });
    });
    var allValues = formattedData.map(function (item) { return item.value; });
    var handleCheckAll = function () {
        setValue(value.length === allValues.length ? [] : allValues);
    };
    var selectAll = function () {
        if (data.length === 0)
            return undefined;
        return (_jsx("div", { children: _jsx(Checkbox, __assign({ indeterminate: value.length > 0 && value.length < allValues.length, checked: value.length === allValues.length, onChange: handleCheckAll }, { children: "Select all" })) }));
    };
    return (_jsx("span", __assign({ onClick: onClick }, { children: _jsx(RSCheckPicker, { searchable: !noSearch, countable: true, block: block, value: value, data: formattedData, placeholder: placeholder, disabled: disabled, onChange: setValue, loading: loading, open: open, onOpen: onOpen, onEntering: onEntering, onClose: onClose, renderExtraFooter: selectAll, renderMenuItem: renderMenuItem, renderValue: renderValue }) })));
}
export default MultipleSelect;
